module.exports = __webpack_public_path__ + "img/order.45a61c2e.png";